import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import {Tag} from "antd";
import React from "react";

const SupplierModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();

    columns.push({key:'code', width: 80, sorter:true,title:<Trans>Code</Trans>});
    columns.push({key:'name', width: 200, sorter:true,title:<Trans>Name</Trans>});
    columns.push({key:'isEu', width: 110, checkboxFilter:true, sorter:true,title:<Trans>EU Member</Trans>});
    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Created Date</Trans>,direction:"desc"});
    columns.push({key:'createdBy', width: 150, sorter:true,title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/suppliers"
    };
}
export default SupplierModel();
